// Delivery timeline: writes the estimated delivery dates, counted from today in the visitor's browser.
if (!customElements.get('delivery-timeline')) {
  const addDuration = (date, amount, unit) => {
    const result = new Date(date);
    if (unit === 'working_days') {
      let left = amount;
      while (left > 0) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) left -= 1;
      }
    } else {
      result.setDate(result.getDate() + (unit === 'weeks' ? amount * 7 : amount));
    }
    return result;
  };

  customElements.define(
    'delivery-timeline',
    class DeliveryTimeline extends HTMLElement {
      connectedCallback() {
        const target = this.querySelector('[data-delivery-dates]');
        if (!target) return;

        const { locale, productionMin, productionMax, productionUnit, shippingMin, shippingMax, shippingUnit } =
          target.dataset;
        const estimate = (production, shipping) =>
          addDuration(addDuration(new Date(), Number(production), productionUnit), Number(shipping), shippingUnit);
        // en-GB writes the day first, the same as in Romanian: "17 Dec"
        const format = new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : locale, { day: 'numeric', month: 'short' });

        const first = format.format(estimate(productionMin, shippingMin));
        const last = format.format(estimate(productionMax, shippingMax));
        target.textContent = first === last ? first : `${first} – ${last}`;
      }
    }
  );
}
